"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportService = void 0;
const tslib_1 = require("tslib");
const notification_service_1 = require("../components/notification.toast/notification.service");
const i18n_1 = require("../i18n");
const index_1 = require("./index");
function handleError(e) {
    notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_EXPORT });
    return Promise.resolve(null);
}
class ExportService {
    constructor() {
        this.__priority = 100;
    }
    export(type_1, selectorsByTag_1) {
        return tslib_1.__awaiter(this, arguments, void 0, function* (type, selectorsByTag, analyticName = type, noPhotos) {
            const units = index_1.Services.UserSettings.units;
            const time = index_1.Services.DateTime.formatTimezoneDate();
            const count = this.getSelectorCount(selectorsByTag);
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const startTime = Date.now();
            const data = {
                type,
                tags: selectorsByTag,
                time,
                units,
                timezone,
                noPhotos
            };
            try {
                const result = yield index_1.Services.Department.rest.Collection.export(data);
                index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Export, analyticName, `${count}`, Date.now() - startTime);
                return result;
            }
            catch (e) {
                return handleError(e);
            }
        });
    }
    kml(selectorsByTag) {
        return this.export('KML', selectorsByTag, 'KML_V2');
    }
    excel(selectorsByTag) {
        return this.export('EXCEL', selectorsByTag, 'EXCEL_V2');
    }
    importableExcel(selectorsByTag) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.export('IMPORTABLE_EXCEL', selectorsByTag, 'EXCEL_IMPORTABLE');
        });
    }
    json(selectorsByTag) {
        return this.export('JSON', selectorsByTag);
    }
    ocalc(selectorsByTag) {
        return this.export('OCALC', selectorsByTag);
    }
    spidacalc(selectorsByTag, noPhotos) {
        return this.export('SPIDACALC', selectorsByTag, 'SPIDACALC', noPhotos);
    }
    poleforeman(selectorsByTag) {
        return this.export('POLEFOREMAN', selectorsByTag);
    }
    ikePoleForeman(selectorsByTag) {
        return this.export('IKE_POLEFOREMAN', selectorsByTag);
    }
    imageZip(selectorsByTag) {
        return this.export('IMAGE_ZIP', selectorsByTag);
    }
    dds(selectorsByTag) {
        return this.export('DDS', selectorsByTag);
    }
    getSelectorCount(selectorsByTag) {
        return Object.keys(selectorsByTag).reduce((count, tagId) => {
            return count += selectorsByTag[tagId].length;
        }, 0);
    }
}
exports.ExportService = ExportService;
//# sourceMappingURL=export.service.js.map